<ion-content>
  <ion-segment mode="md">
    <ion-segment-button
      value="/dashboard/settings/portals/internal"
      routerLink="/dashboard/settings/portals/internal"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>Internal Customer Portal</ion-label>
    </ion-segment-button>
    <ion-segment-button
      value="/dashboard/settings/portals/external"
      routerLink="/dashboard/settings/portals/external"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>External Customer Portal</ion-label>
    </ion-segment-button>
  </ion-segment>
  <router-outlet></router-outlet>
</ion-content>
